const encodePathSegment = (segment) => {
  try {
    return encodeURIComponent(decodeURIComponent(segment));
  } catch {
    return encodeURIComponent(segment);
  }
};

export const resolveProductImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const path = url.startsWith('/') ? url : `/${url}`;
  const [root, ...segments] = path.split('/').filter(Boolean);
  if (!segments.length) return path;
  return `/${root}/${segments.map(encodePathSegment).join('/')}`;
};

export const getCartLineKey = (product) => {
  if (product?.selectedVariant?.id) {
    const backup = product?.backupVariant?.id || 'none';
    return `${product.id}:${product.selectedVariant.id}:${backup}`;
  }
  return String(product.id);
};

export const getCartDisplayName = (item) => {
  if (item?.selectedVariant?.name) {
    let label = `${item.name} — ${item.selectedVariant.name}`;
    if (item?.backupVariant?.name) {
      label += ` (backup: ${item.backupVariant.name})`;
    }
    return label;
  }
  return item.name;
};
